import React from 'react';
import {observer} from "mobx-react";
import {MenuItemComponentProps} from "../../services/menu-items-common/menu-item-component-props.interface";
import {BottomNavigationBarMenuItemBox} from "./boxes/menu-item/bottom-navigation-bar-menu-item.box";
import {BottomNavigationBarMenuItemTextBox} from "./boxes/menu-item-text/bottom-navigation-bar-menu-item-text.box";
import {BottomNavigationBarMenuItemIconComponent} from "./bottom-navigation-bar-menu-item-icon.component";
import {CyClass} from "../../../common/cy-classes";
import {useServices} from "../../react-hooks/use-services.hook";

export const BottomNavigationBarMenuItemComponent: React.FC<MenuItemComponentProps> = observer((props) => {

    const services = useServices();

    const menuItem = props.menuItem;

    const handleLinkClick = async ()  => {
        services.bottomNavigationBar.activeMenuItemKey = props.menuItem.key;
        await props.menuItem.execute();
    }

    let isActive;

    if (services.bottomNavigationBar.activeMenuItemKey) {
        isActive = props.menuItem.key === services.bottomNavigationBar.activeMenuItemKey;
    } else {
        isActive = props.menuItem.isMatchToCurrentUrl;
    }

    return (
        <BottomNavigationBarMenuItemBox key={menuItem.key}
                                        onClick={handleLinkClick}
                                        isActive={isActive}
                                        type={menuItem.key}
                                        className={CyClass('cy-hybrid-menu-item')}>
            <BottomNavigationBarMenuItemIconComponent menuItem={menuItem} isActive={isActive}/>
            <BottomNavigationBarMenuItemTextBox isActive={isActive}>
                {menuItem.text}
            </BottomNavigationBarMenuItemTextBox>
        </BottomNavigationBarMenuItemBox>
    );
});